import styled from '@emotion/styled';
import { colors } from 'theme/colors';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledTextField = {
  fieldset: {
    borderRadius: 4,
  },
  input: {
    fontSize: 14,
    height: 32,
    backgroundColor: `${colors.white}`,
    boxSizing: 'border-box',
  },
  textarea: {
    fontSize: 14,
  },
  'input::placeholder, textarea::placeholder': {
    fontSize: 14,
    fontWeight: 400,
    color: `${colors.gray400}`,
    fontFamily: 'NotoSansRegular, sans-serif',
    opacity: 1,
  },
  '& .MuiPickersOutlinedInput-notchedOutline': {
    borderRadius: '4px',
  },
  '& .MuiPickersOutlinedInput-root': {
    width: '100%',
    height: '32px',
    fontSize: '14px',
    fontWeight: 600,
    backgroundColor: colors.white,

    '& fieldset ': {
      borderColor: colors.gray400,
      borderWidth: '1px',
    },

    '&:hover:not(.Mui-focused, .Mui-disabled) fieldset ': {
      borderColor: colors.primary400,
    },

    '&.Mui-focused fieldset ': {
      borderColor: colors.primary400,
      borderWidth: '2px',
    },

    '&:active fieldset ': {
      borderColor: colors.primary900,
      borderWidth: '1px',
    },

    '&.Mui-error fieldset ': {
      borderColor: colors.error800,
      borderWidth: '1px',
    },

    '& .MuiInputAdornment-root .MuiIconButton-root ': {
      color: colors.gray900,
    },

    '&.Mui-disabled .MuiInputAdornment-root .MuiIconButton-root ': {
      color: colors.gray400,
    },
  },
  '& .MuiAutocomplete-input': {
    marginBottom: 4,
    marginTop: '-9px',
    marginLeft: '-10px',
    marginRight: '-10px',
    paddingLeft: '10px !important',
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '4px !important',
    bottom: '-15px !important',
  },
};

export const StyledDatePicker = styled(DatePicker)({
  '& ': {
    color: 'red',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
});

export const StyledInnerWrapper = styled.div`
  font-size: 14px;
  margin-bottom: 3px;
  height: 32px;

  & .MuiOutlinedInput-root {
    width: 100%;
    height: 32px;
  }

  & .MuiSelect-select {
    height: 32px;
    box-sizing: border-box;
    background-color: ${colors.white};
  }
`;
